// extracted by mini-css-extract-plugin
export default {"date-row":"TableGroup_date-row__Jd+-w","body":"TableGroup_body__fEVTW","date":"TableGroup_date__LEEqA","quantity":"TableGroup_quantity__dSjsO"};